(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4991],{

/***/ 10996:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-lecture/special-lecture-player",
      function () {
        return __webpack_require__(88449);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/ic_download.af14471d.svg","height":24,"width":25});

/***/ }),

/***/ 39996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/ic_play.22096508.svg","height":24,"width":24});

/***/ }),

/***/ 88449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SpecialLecturePlayerPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/VStack.js
var VStack = __webpack_require__(67974);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Box/index.js + 2 modules
var Box = __webpack_require__(4934);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Text/index.js
var Text = __webpack_require__(80775);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/HStack.js
var HStack = __webpack_require__(79305);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/basic/ScrollView/ScrollView.js
var ScrollView = __webpack_require__(7676);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(77266);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(96258);
// EXTERNAL MODULE: ../../packages/app/features/special-lecture/special-lecture-player/video-list.ts
var video_list = __webpack_require__(40893);
// EXTERNAL MODULE: ../../packages/app/features/component/header/Header.tsx
var Header = __webpack_require__(90398);
// EXTERNAL MODULE: ../../packages/app/features/component/BackButton.tsx + 1 modules
var BackButton = __webpack_require__(36949);
// EXTERNAL MODULE: ../../packages/app/features/component/safe-area-flex/SafeAreaFlex.tsx
var SafeAreaFlex = __webpack_require__(49996);
// EXTERNAL MODULE: ../../packages/app/colors/index.tsx
var colors = __webpack_require__(8521);
// EXTERNAL MODULE: ../../packages/app/features/component/svg.tsx
var svg = __webpack_require__(60092);
// EXTERNAL MODULE: ../../node_modules/expo-file-system/build/FileSystem.js + 17 modules
var FileSystem = __webpack_require__(56851);
// EXTERNAL MODULE: ../../packages/app/utils/format.ts
var format = __webpack_require__(88889);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/core/constants/route-path/index.ts + 1 modules
var route_path = __webpack_require__(20458);
// EXTERNAL MODULE: ../../packages/app/features/component/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(93804);
;// CONCATENATED MODULE: ../../packages/app/features/special-lecture/special-lecture-player/screen.tsx














function SpecialLecturePlayer() {
    const router = (0,next_router.useRouter)();
    if (!router.isReady) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {});
    }
    const selectedTab = router.query.selectedTab;
    const selectedVideoIndexString = router.query.selectedVideoIndex;
    const selectedVideoIndex = Number.parseInt(selectedVideoIndexString);
    const videoList = selectedTab === "STUDENT" ? video_list/* StudentVideoList */.nZ : video_list/* ParentVideoList */.Uc;
    const selectedVideo = videoList[selectedVideoIndex];
    async function goToPlayVideo(selectedVideoIndex) {
        await router.push({
            pathname: route_path/* PATH.SPECIAL_LECTURE_PLAYER */.mD.Eo,
            query: {
                selectedTab,
                selectedVideoIndex
            }
        });
    }
    async function materialFileDownload() {
        if (!selectedVideo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        const downloadURL = "".concat(video_list/* baseMaterialURL */.o2).concat(selectedVideo.materialName);
        if (Platform/* default.OS */.Z.OS === "web") {
            const res = await fetch(downloadURL, {
                method: "get",
                mode: "no-cors",
                referrerPolicy: "no-referrer"
            });
            const blob = await res.blob();
            const aElement = document.createElement("a");
            aElement.setAttribute("download", selectedVideo.krMaterialName);
            const href = URL.createObjectURL(blob);
            aElement.href = href;
            aElement.setAttribute("target", "_blank");
            aElement.click();
            URL.revokeObjectURL(href);
        } else {
            var _documentDirectory;
            const documentDirectory = (_documentDirectory = FileSystem/* documentDirectory */.Ar) !== null && _documentDirectory !== void 0 ? _documentDirectory : "";
            await FileSystem/* downloadAsync */.ax(downloadURL, documentDirectory + selectedVideo.materialName);
        }
    }
    if (!selectedVideo) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
        bgColor: "singletons.white",
        maxWidth: "500px",
        alignSelf: "center",
        w: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                title: "".concat(selectedVideoIndex + 1, "강 ").concat((0,format/* truncateText */.aF)(selectedVideo.title, 15)),
                leftButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeAreaFlex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                controls: true,
                                style: {
                                    maxHeight: "281px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "".concat(video_list/* baseVideoURL */.GN).concat(selectedVideo.videoName),
                                    type: "video/mp4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                                        p: "24px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                size: "p_s/500",
                                                color: colors/* default.grey600 */.Z.grey600,
                                                children: [
                                                    selectedVideoIndex + 1,
                                                    "강"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mt: "12px",
                                                size: "h6/700",
                                                color: colors/* default.grey900 */.Z.grey900,
                                                children: selectedVideo.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mt: "8px",
                                                mb: "24px",
                                                size: "p_m/500",
                                                color: colors/* default.grey800 */.Z.grey800,
                                                children: selectedVideo.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TouchableOpacity/* default */.Z, {
                                                onPress: materialFileDownload,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HStack/* default */.Z, {
                                                    py: "12px",
                                                    height: "48px",
                                                    borderWidth: "1px",
                                                    borderRadius: "12px",
                                                    borderColor: colors/* default.grey200 */.Z.grey200,
                                                    justifyContent: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                size: "btn_l/700",
                                                                color: colors/* default.grey500 */.Z.grey500,
                                                                children: "자료 받기"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                                                style: {
                                                                    marginLeft: "8px"
                                                                },
                                                                width: "25px",
                                                                height: "24px",
                                                                asset: __webpack_require__(14972),
                                                                src: "/special-lecture/ic_download.svg"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: "16px",
                                        backgroundColor: colors/* default.grey100 */.Z.grey100,
                                        height: "10px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                                        p: "24px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "btn_l/700",
                                                color: colors/* default.grey900 */.Z.grey900,
                                                children: "다음 특강"
                                            }),
                                            videoList.slice(selectedVideoIndex + 1).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollView/* ScrollView */.p, {
                                                mt: "24px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                                                    children: videoList.slice(selectedVideoIndex + 1).map((videoInfo, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TouchableOpacity/* default */.Z, {
                                                            onPress: async ()=>{
                                                                await goToPlayVideo(index + 1 + selectedVideoIndex);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                                                        py: "8px",
                                                                        justifyContent: "space-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                                                                        width: "24px",
                                                                                        height: "24px",
                                                                                        asset: __webpack_require__(39996),
                                                                                        src: "/special-lecture/ic_play.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                                        ml: "8px",
                                                                                        width: "36px",
                                                                                        size: "p_s/500",
                                                                                        color: colors/* default.grey900 */.Z.grey900,
                                                                                        children: [
                                                                                            index + 1 + selectedVideoIndex + 1,
                                                                                            "강"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                        size: "p_s/500",
                                                                                        color: colors/* default.grey900 */.Z.grey900,
                                                                                        children: (0,format/* truncateText */.aF)(videoInfo.title, 20)
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                size: "p_s/600",
                                                                                color: colors/* default.grey500 */.Z.grey500,
                                                                                children: videoInfo.playTime
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        height: "1px",
                                                                        backgroundColor: colors/* default.grey200 */.Z.grey200
                                                                    })
                                                                ]
                                                            })
                                                        }, index + selectedVideoIndex))
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                                                mt: "20px",
                                                alignItems: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    size: "p_s/500",
                                                    color: colors/* default.grey900 */.Z.grey900,
                                                    children: "다음 특강내용이 없어요"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/app/features/component/guards/AuthGuard.tsx
var AuthGuard = __webpack_require__(62526);
;// CONCATENATED MODULE: ./src/pages/special-lecture/special-lecture-player/index.tsx



SpecialLecturePlayerPage.getLayout = function(page) {
    return (0,jsx_runtime.jsx)(AuthGuard/* default */.Z, {
        children: page
    });
};
function SpecialLecturePlayerPage() {
    return (0,jsx_runtime.jsx)(SpecialLecturePlayer, {});
}


/***/ }),

/***/ 98978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ userFetcher; }
/* harmony export */ });
/* harmony import */ var _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4664);
/* harmony import */ var app_utils_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44064);
/* harmony import */ var app_utils_storage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15551);



let repository;
function userRepository() {
    if (repository) return repository;
    repository = {
        getUserInfo: async ()=>{
            const { data  } = await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/ug/consulting/user");
            return data;
        },
        updateUserInfo: async (newUser)=>{
            await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].patch */ .Z.patch("/ug/consulting/user", {
                ...newUser
            });
        },
        userQuit: async (quitReason)=>{
            await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/ug/consulting/user-quit", {
                quitReason
            });
        },
        updateLastLoginDate: async ()=>{
            await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].patch */ .Z.patch("/ug/consulting/users/last-login-date");
        }
    };
    return repository;
}
/* harmony default export */ __webpack_exports__["Z"] = (userRepository());
const userFetcher = async ()=>{
    const idToken = app_utils_storage__WEBPACK_IMPORTED_MODULE_2__/* .getIdToken */ .lI();
    if (!idToken) {
        throw new _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .ClientError */ .XF({
            message: "로그인이 되어있지 않습니다.",
            code: _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .EMPTY_TOKEN */ .Wq
        });
    }
    const { data  } = await app_utils_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/ug/consulting/user");
    if (!data) {
        throw new _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .ClientError */ .XF({
            message: "존재하지 않는 유저입니다.",
            code: _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .INVALID_TOKEN */ .fs
        });
    }
    return data;
};


/***/ }),

/***/ 36949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ component_BackButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(62000);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(38879);
// EXTERNAL MODULE: ../../packages/ui/index.ts + 53 modules
var ui = __webpack_require__(38339);
// EXTERNAL MODULE: ../../packages/app/colors/index.tsx
var colors = __webpack_require__(8521);
;// CONCATENATED MODULE: ../../packages/ui/components/LeftButton.tsx




function LeftButton(param) {
    let { onClick , color  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* IconButton */.hU, {
        size: "small",
        disableRipple: true,
        sx: {
            color: color !== null && color !== void 0 ? color : colors/* default.grey900 */.Z.grey900,
            "&.MuiButtonBase-root:hover": {
                backgroundColor: "transparent"
            }
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {})
    });
}

// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(57829);
;// CONCATENATED MODULE: ../../packages/app/features/component/BackButton.tsx





const BackButton = (param)=>{
    let { iconType ="left" , onClickBack , color  } = param;
    const { push , back  } = (0,router.useRouter)();
    async function goToMainOrBack() {
        if (!lib/* isMobile */.tq) {
            const returnUrl = new URLSearchParams(window.location.search).get("return-url");
            if (returnUrl) {
                await push("/");
                return;
            }
        }
        back();
    }
    const onPress = onClickBack !== null && onClickBack !== void 0 ? onClickBack : goToMainOrBack;
    if (iconType === "close") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
            onClick: onPress,
            color: color
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftButton, {
        onClick: onPress,
        color: color
    });
};
/* harmony default export */ var component_BackButton = (BackButton);


/***/ }),

/***/ 62526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthGuard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89930);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _bridge_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38339);
/* harmony import */ var app_api_UserRepository__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98978);
/* harmony import */ var app_hooks_useUser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61432);
/* harmony import */ var app_features_component_LoadingSpinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93804);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var app_hooks_useAuth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62181);
/* harmony import */ var _bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20458);










const { updateLastLoginDate  } = app_api_UserRepository__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
function AuthGuard(param) {
    let { children , toast =true  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { isLoading , error , isLoggedOut  } = (0,app_hooks_useUser__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    if (isLoading || !router.isReady) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_features_component_LoadingSpinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
    }
    if (isLoggedOut) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoggedOut, {
            toast: toast
        });
    }
    if (error) {
        // go to error boundary
        // 예기치 못한 에러
        throw error;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoggedIn, {
        children: children
    });
}
function LoggedOut(param) {
    let { toast  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { logout  } = (0,app_hooks_useAuth__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleLoggedOut = async ()=>{
            if (toast) {
                _bridge_ui__WEBPACK_IMPORTED_MODULE_2__/* .Toast.show */ .FNi.show({
                    description: "로그인 이후 이용 가능합니다."
                });
            }
            const isLandingToMainPage = [
                window.location.pathname === "/parent/",
                new URLSearchParams(window.location.search).get("path") === "my-page"
            ].some(lodash_es__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z);
            // 인코딩된 url을 넘겨주지 않으면 주소의 "&"부터
            // 주소창에서 없어지면서 해당 페이지로 넘어가질 않음
            const url = isLandingToMainPage ? "/log-in?return-url=/" : "/log-in?return-url=".concat(encodeURIComponent(window.location.pathname + window.location.search));
            await router.push(url);
        };
        handleLoggedOut().catch(console.error);
    }, [
        logout,
        router,
        toast
    ]);
    return null;
}
function LoggedIn(param) {
    let { children  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { user  } = (0,app_hooks_useUser__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    const isDaekyoUser = (user === null || user === void 0 ? void 0 : user.userDetailType) === "daekyo";
    const isInitUser = (user === null || user === void 0 ? void 0 : user.gender) === "U";
    const isNeedToRouting = isDaekyoUser && isInitUser && router.pathname !== _bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.AUTH_AGREEMENT */ .mD.Yl;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        updateLastLoginDate().catch(console.error);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isNeedToRouting) {
            return;
        }
        void router.replace(_bridge_core_constants_route_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.AUTH_AGREEMENT */ .mD.Yl);
    }, [
        isNeedToRouting,
        router
    ]);
    if (isNeedToRouting) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
}


/***/ }),

/***/ 40893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GN": function() { return /* binding */ baseVideoURL; },
/* harmony export */   "Uc": function() { return /* binding */ ParentVideoList; },
/* harmony export */   "nZ": function() { return /* binding */ StudentVideoList; },
/* harmony export */   "o2": function() { return /* binding */ baseMaterialURL; }
/* harmony export */ });
/* harmony import */ var app_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37326);

// 특강 자료 https://drive.google.com/drive/folders/19_yJLVD07T5K1tu-9UaYDUYlQ_m5CIEy
const baseVideoURL = app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_DEV */ .TQ ? "https://bridge.knowre-dev.com/video/" : app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_STG */ .YO ? "https://stg.briiidgeproject.com/video/" : app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_STG2 */ .jf ? "https://stg2.briiidgeproject.com/video/" : app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_PROD */ .XK ? "https://briiidgeproject.com/video/" : "https://bridge.knowre-dev.com/video/" // local
;
const baseMaterialURL = "/material/";
const StudentVideoList = [
    {
        title: "갓생사는 7가지 방법",
        description: "왜 공부를 해야하는지, 공부를 하면 무엇이 좋은 것인지 알려주는 강의입니다.",
        videoName: "student_lecture_001.mp4",
        playTime: "51:41",
        materialName: "s1.pdf",
        krMaterialName: "1강 갓생 사는 방법 7가지.pdf"
    },
    {
        title: "공부를 잘하고 싶으면 당연히 많이 해야 잘한다.",
        description: "공부를 잘하는 특별한 방법은 없다. 내가 가고 싶은 대학 몇시간 공부해야 할지 알려주는 강의입니다.",
        videoName: "student_lecture_002.mp4",
        playTime: "13:46",
        materialName: "s2.pdf",
        krMaterialName: "2강 공부를 잘하고 싶으면 당연히 많이 해야 잘한다.pdf"
    },
    {
        title: "학원은 원래 다니는 것이 아니다.",
        description: "학원은 원래 안 다니는 것이다. 학원 감별법을 알려주는 강의입니다.",
        videoName: "student_lecture_003.mp4",
        playTime: "53:40",
        materialName: "s3.pdf",
        krMaterialName: "3강 학원은 원래 다니는 것이 아니다.pdf"
    },
    {
        title: "시험공부는 평상시에 하는 것이다.",
        description: "내신 1등하는 방법은 아주 단순하다. 학원 다니지 않아도 1등하는 방법을 알려주는 강의입니다. ",
        videoName: "student_lecture_004.mp4",
        playTime: "41:18",
        materialName: "s4.pdf",
        krMaterialName: "4강 시험 공부는 평상시에 하는 것이다.pdf"
    },
    {
        title: "공부 방법도  MBTI에 맞춰야 잘할 수 있다.",
        description: "내 성격에 맞게 공부해야 힘든 공부도 조금 덜 힘들 수 있다. 내 성격에 맞는 공부 방법을 알려주는 강의입니다.",
        videoName: "student_lecture_005.mp4",
        playTime: "45:29",
        materialName: "s5.pdf",
        krMaterialName: "5강 공부방법도 MBTI에 맞춰야 잘할 수 있다.pdf"
    },
    {
        title: "학교 수업 직전/ 직후 3분은 게임케쉬다.",
        description: "수업 전후 3분은 시험기간 공부 3시간의 효과가 있다는 것을 알려주는 강의입니다.",
        videoName: "student_lecture_006.mp4",
        playTime: "14:02",
        materialName: "s6.pdf",
        krMaterialName: "6강 수업 직전, 직후 3분은 게임 캐시다.pdf"
    }
];
const ParentVideoList = [
    {
        title: "쉽고 빠른길은 어디에도 없습니다. 많이 시키십시오.",
        description: "광고에 끌려 다니지 마시고, 제대로 내 아이를 공부시키는 방법을 알려주는 강의입니다.",
        videoName: "parent_lecture_001.mp4",
        playTime: "15:51",
        materialName: "p1.pdf",
        krMaterialName: "1강_특별한 방법은 없습니다.그냥 많이 시키십시오.pdf"
    },
    {
        title: "공부 안하는 아이 공부 시키는 방법",
        description: "공부 시작이 어려운 아이를 어떻게 해야 공부를 하게 만드는지 알려주는 강의입니다.",
        videoName: "parent_lecture_002.mp4",
        playTime: "01:08:22",
        materialName: "p2.pdf",
        krMaterialName: "2강_공부 안하는 아이 공부시키는 방법.pdf"
    },
    {
        title: "1시간 만에 끝내는 대학 입시",
        description: "냉정한 현실 입시를 아셔야 아이를 잘 지도할 수 있습니다. 지금의 대입을 현실적으로 알려주는 강의입니다.",
        videoName: "parent_lecture_003.mp4",
        playTime: "47:34",
        materialName: "p3.pdf",
        krMaterialName: "3강_1시간 만에 끝내는 대학 입시.pdf"
    },
    {
        title: "EBS만 제대로 해도 SKY는 충분합니다.",
        description: "대치동과 같은 공부 효율을 낼 수 있는 EBS커리큘럼을 알려주는 강의입니다.",
        videoName: "parent_lecture_004.mp4",
        playTime: "30:11",
        materialName: "p4.pdf",
        krMaterialName: "4강_EBS만 제대로 해도 SKY진학 충분합니다.pdf"
    },
    {
        title: "이런 학원 절대 No! 내신학원 선택하는 방법",
        description: "고등학교에 들어가면 성적이 폭락하는 아이로 만들지 않기위한 제대로된 학원 선택 방법입니다.",
        videoName: "parent_lecture_005.mp4",
        playTime: "05:08",
        materialName: "p5.pdf",
        krMaterialName: "5강_내신학원의 필요성.pdf"
    },
    {
        title: "내신 시험 만점을 만드는 부모의 관리 방법",
        description: "학원에 보내도 성적이 오르지 않는 아이, 집에서 제대로 공부시키는 방법을 알려주는 강의입니다.",
        videoName: "parent_lecture_006.mp4",
        playTime: "45:35",
        materialName: "p6.pdf",
        krMaterialName: "6강_내신 시험 만점을 만드는 부모의 관리 방법.pdf"
    }
];


/***/ }),

/***/ 61432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useSuspenseUser; },
/* harmony export */   "a": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4664);
/* harmony import */ var app_api_UserRepository__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98978);
/* harmony import */ var app_common_constants_swr_key__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94880);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3255);




// { revalidate: false } 일 경우 유저 정보 갱신 안함.
// 외부에 인해 변하는 유저의 실시간 데이터가 필요할 때 { revalidate: true }
// ex) user.consultant, user.emailAuth, ... 등등
const useSuspenseUser = function() {
    let { revalidate =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data: user , mutate  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(app_common_constants_swr_key__WEBPACK_IMPORTED_MODULE_2__/* .API_USER */ .zh, app_api_UserRepository__WEBPACK_IMPORTED_MODULE_3__/* .userFetcher */ .E, {
        suspense: true,
        ...!revalidate && {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }
    });
    return {
        mutate,
        user
    };
};
const useUser = function() {
    let { revalidate =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data: user , error , mutate , isLoading , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(app_common_constants_swr_key__WEBPACK_IMPORTED_MODULE_2__/* .API_USER */ .zh, app_api_UserRepository__WEBPACK_IMPORTED_MODULE_3__/* .userFetcher */ .E, {
        suspense: false,
        ...!revalidate && {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }
    });
    // 토큰이 없거나 토큰으로 조회한 유저 정보가 없을 때
    const isLoggedOut = (0,_bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .isClientError */ .pI)(error) && (error.code === _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .EMPTY_TOKEN */ .Wq || error.code === _bridge_core_util_error__WEBPACK_IMPORTED_MODULE_0__/* .INVALID_TOKEN */ .fs);
    const isLoggedIn = !error && !!user;
    return {
        error,
        mutate,
        user,
        isLoading,
        isLoggedOut,
        isLoggedIn,
        isValidating
    };
};


/***/ }),

/***/ 88889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZC": function() { return /* binding */ formatSeconds; },
/* harmony export */   "aF": function() { return /* binding */ truncateText; },
/* harmony export */   "nE": function() { return /* binding */ convertPhoneNumber; },
/* harmony export */   "vW": function() { return /* binding */ convertPhoneNumberFormat; }
/* harmony export */ });
/* unused harmony export toLocalPhoneNumber */
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44942);

const toLocalPhoneNumber = (globalPhoneNumber)=>{
    if (!globalPhoneNumber.startsWith("+")) {
        return globalPhoneNumber;
    }
    const fullPhoneNumber = "0".concat(globalPhoneNumber.slice(3));
    return fullPhoneNumber.replace(/^(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
};
function convertPhoneNumberFormat(value) {
    return value.substring(0, 3) + "-" + value.substring(3, 7) + "-" + value.substring(7, 11);
}
const convertPhoneNumber = lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(toLocalPhoneNumber, convertPhoneNumberFormat);
function truncateText(input, maxLength) {
    let truncateSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    if (!input) return "";
    return input.length > maxLength ? input.substring(0, maxLength - truncateSize) + "..." : input;
}
function formatSeconds(seconds) {
    const hour = Math.floor(seconds / 3600);
    const minute = Math.floor(seconds % 3600 / 60);
    const second = Math.floor(seconds % 60);
    return "".concat(hour.toString().padStart(2, "0"), ":").concat(minute.toString().padStart(2, "0"), ":").concat(second.toString().padStart(2, "0"));
}


/***/ }),

/***/ 62000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CloseButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _bridge_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38339);
/* harmony import */ var app_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8521);




const CloseButton = (param)=>{
    let { onClick , color  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_bridge_ui__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
        borderRadius: 1,
        sx: {
            cursor: "pointer"
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/close-icon.svg",
            alt: "close",
            width: 24,
            height: 24,
            style: {
                color: color !== null && color !== void 0 ? color : app_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].grey900 */ .Z.grey900
            }
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4942,9070,9774,2888,179], function() { return __webpack_exec__(10996); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);